
import { Action, createReducer, on } from '@ngrx/store';
import { IVehicle } from '@interfaces/vehicle.interface';
import { VehicleActions } from './actions';

interface VehicleState {
  vehicle: IVehicle | null;
  vehiclesList: IVehicle[];
  driver: IVehicle | null;
  error: any;
  loading: boolean;
  message: string | null;
}

const initialState: VehicleState = {
  vehicle: null,
  vehiclesList: [],
  driver: null,
  error: null,
  loading: false,
  message: null,
};


const featureReducer = createReducer(
  initialState,
  on(VehicleActions.reset, (state) => {
    return {
      ...resetFlags(state)
    };
  }),
  on(VehicleActions.getByLicensePlate, (state) => {
    return {
      ...resetFlags(state)
    };
  }),
  on(VehicleActions.create, (state) => {
    return {
      ...resetFlags(state),
      loading: true,
    };
  }),
  on(VehicleActions.createSuccess, (state, { vehicle }) => {
    return {
      ...resetFlags(state),
      vehicle,
      message: 'Vehiculo registrado satisfactoriamente.'
    };
  }),
  on(VehicleActions.getByLicensePlateSuccess, (state, { vehicle }) => {
    return {
      ...resetFlags(state),
      vehicle
    };
  }),
  on(VehicleActions.error, (state, { error }) => {
    return {
      ...resetFlags(state),
      error: error.error

    }
  }),
  on(VehicleActions.resetVehicle, (state ) => {
    return {
      ...resetFlags(state),
      vehicle: null
    }
  })
);

const resetFlags = (state: VehicleState): VehicleState => {
  return {
    ...state,
    error: null,
    loading: false,
    message: null,
  };
};

function reducer(state: VehicleState | undefined, action: Action) {
  return featureReducer(state, action);
}
const getError = (state: VehicleState) => state.error;
const getLoading = (state: VehicleState) => state.loading;
const getMessage = (state: VehicleState) => state.message;

const getVehicle = (state: VehicleState) => state.vehicle;
const getVehicleList = (state: VehicleState) => state.vehiclesList;
export {
  VehicleState
}

export const VehicleReducer = {
  reducer,
  getError,
  getLoading,
  getMessage,
  getVehicle,
  getVehicleList

}
